module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-area-wrapper"
  }, [_c('div', {
    staticClass: "share-button"
  }, [_c('button', {
    class: _vm.$i18n.locale() == 'ar' ? 'btn btn-success btn-xs pull-left' : 'btn btn-success btn-xs pull-right',
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$store.commit('setShowShare', true)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Share')))])]), _vm._v(" "), _c('h1', {
    staticClass: "page-top-title"
  }, [(_vm.$store.getters.getLoginAsUser) ? _c('span', [_vm._v(_vm._s(_vm.$t('Login as User')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('Login as Establishment')))])]), _vm._v(" "), (_vm.$store.getters.getLoginAsUser) ? _c('div', {
    staticClass: "user-login"
  }, [_c('form', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "title": _vm.$t('Country'),
      "id": "country-addon1"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('Donation Destination')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.country),
      expression: "country"
    }],
    staticClass: "form-control",
    attrs: {
      "aria-describedby": "nationality-addon1"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.country = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.updateAPI]
    }
  }, _vm._l((_vm.$store.getters.getTopCountries), function(ctry, i) {
    return _c('option', {
      domProps: {
        "selected": i == 1,
        "value": ctry.code
      }
    }, [_vm._v(_vm._s(ctry.name))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr",
      "title": _vm.$t('Email')
    }
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.login.mail),
      expression: "login.mail"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "mail",
      "aria-describedby": "email-addon1",
      "type": "email",
      "placeholder": _vm.$t('Email')
    },
    domProps: {
      "value": _vm.login.email,
      "value": (_vm.login.mail)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.login.mail = $event.target.value
      }, _vm.updateEmail]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr",
      "title": _vm.$t('Password')
    }
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.login.password),
      expression: "login.password"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "password",
      "aria-describedby": "password-addon1",
      "type": "password",
      "placeholder": _vm.$t('Password')
    },
    domProps: {
      "value": _vm.login.password,
      "value": (_vm.login.password)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.login.password = $event.target.value
      }, _vm.updatePassword]
    }
  })]), _vm._v("\n\n      " + _vm._s(_vm.$t("If you don't have an account yet")) + " "), _c('a', {
    on: {
      "click": _vm.goToSignupPage
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('Sign up here')))]), _vm._v(" "), _c('p', {
    staticClass: "tpbutton btn-toolbar text-center"
  }, [_c('button', {
    staticClass: "btn navbar-btn btn-primary login-btn",
    on: {
      "click": _vm.loginUser
    }
  }, [_c('i', {
    staticClass: "fa fa-paper-plane",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('Login')))]), _vm._v(" "), _c('button', {
    staticClass: "btn navbar-btn btn-primary login-btn",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        _vm.$store.commit('setShowSocialLogin', true)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-external-link fa-fw"
  }), _vm._v(" " + _vm._s(_vm.$t('Social Login')))])]), _vm._v("\n\n      " + _vm._s(_vm.$t('Remember me')) + " "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rememberMe),
      expression: "rememberMe"
    }],
    attrs: {
      "name": "remember_me",
      "aria-describedby": "password-addon1",
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.rememberMe,
      "value": _vm.rememberMe,
      "checked": Array.isArray(_vm.rememberMe) ? _vm._i(_vm.rememberMe, _vm.rememberMe) > -1 : (_vm.rememberMe)
    },
    on: {
      "click": _vm.setRememberMe,
      "__c": function($event) {
        var $$a = _vm.rememberMe,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.rememberMe,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.rememberMe = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.rememberMe = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.rememberMe = $$c
        }
      }
    }
  })]), _vm._v(" "), (_vm.$store.getters.getShowVideo) ? _c('video-frame') : _vm._e()], 1) : _c('div', {
    staticClass: "POS-login"
  }, [_c('login-pos-form')], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-xs btn-block",
    on: {
      "click": _vm.gotToLoginPOS
    }
  }, [(!_vm.$store.getters.getLoginAsUser) ? _c('span', [_vm._v(_vm._s(_vm.$t('Login as User')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('Login as Establishment')))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "email-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "password-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-lock fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3299cfbf"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 301
// module chunks = 1